import {
  MESSAGE_LISTE_SUCCES,
  MESSAGE_LISTE_ECHEC,
  MESSAGE_LISTE_RESET,
  MESSAGE_LISTE_REQUETTE,
  MESSAGE_CREE_REQUETTE,
  MESSAGE_CREE_SUCCES,
  MESSAGE_CREE_ECHEC,
  MESSAGE_SUPP_REQUETTE,
  MESSAGE_SUPP_SUCCES,
  MESSAGE_SUPP_ECHEC,
} from "../constantes/messageConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back`;
import { store } from "../store";
let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();
export const messagesListe = () => async (dispatch) => {
  dispatch({ type: MESSAGE_LISTE_RESET });
  try {
    dispatch({ type: MESSAGE_LISTE_REQUETTE });

    const { data } = await axios.get(`${uri}/api/messages`);

    dispatch({ type: MESSAGE_LISTE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: MESSAGE_LISTE_ECHEC, payload: error });
  }
};

export const messageCreer =
  ({
    cod_user,

    nom_user,
    type_user,
    obj_msg,
    text_msg,
    date_msg,
    sense,
  }) =>
  async (dispatch) => {
    try {
      dispatch({ type: MESSAGE_CREE_REQUETTE });

      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${uri}/api/messages`,
        {
          cod_user,

          nom_user,
          type_user,
          obj_msg,
          text_msg,
          date_msg,
          sense,
        },
        config
      );
      dispatch({ type: MESSAGE_CREE_SUCCES, payload: data });
    } catch (error) {
      dispatch({
        type: MESSAGE_CREE_ECHEC,
        payload: error.response && error.response.data.message,
      });
    }
  };

export const messageSupp = (id) => async (dispatch) => {
  try {
    dispatch({ type: MESSAGE_SUPP_REQUETTE });

    const { data } = await axios.delete(`${uri}/api/messages/${id}`);

    dispatch({ type: MESSAGE_SUPP_SUCCES, payload: data });
    alert("Suppression est términer avec succes!");
  } catch (error) {
    console.log(error);
    dispatch({ type: MESSAGE_SUPP_ECHEC, payload: error });
  }
};
